module.exports = "/images/vendor/flag-icon-css/flags/4x3/mz.svg?ef4657da4e39ea91de728d93ce59d7c9";